export let popular = [
    {
        id:1,
        title:'اولین کباب کوبیده در ایران',
        img:process.env.PUBLIC_URL + '/images/Kabab-koobideh.jpg',
        excerpt:'کباب کوبیده یکی از اصیل و پرطرفدارترین غذاهای ایرانی است. غیر ممکن است که ایرانی باشید و حدأقل یکبار در زندگی اتان کباب کوبیده نخورده باشید. اما آیا تا به حال با خودتان فکر کرده اید که این غذای خوشمزه، برای اولین بار، چه زمانی و توسط چه کسی ابداع شد؟'
    },
];